import {useFormSubmission} from '../../contexts/form-submission-context';
import {ChevronLeft} from 'lucide-react';
import {ChevronRight} from 'lucide-react';
import {Send} from 'lucide-react';
import { useLanguage } from '@shondalai/ui-commons';

export function FormNavigation() {
  const {
    form,
    navigation,
    previousPage,
    nextPage,
    submitForm,
    isSubmitting,
    isDraftSaving,
    pages,
    currentPage
  } = useFormSubmission();
  const { t } = useLanguage();

  if (!form || pages.length === 0) return null;

  const currentPageData = pages[currentPage];
  const hasErrors = currentPageData?.errors?.length > 0;

  return (
    <div className="flex items-center justify-between gap-3 pt-6 mt-6 border-t border-border/30">
      {/* Previous Button */}
      {navigation.canGoPrevious ? (
        <button
          onClick={previousPage}
          disabled={isSubmitting || isDraftSaving}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium
                     bg-background border border-border/40 rounded-lg
                     transition-all duration-200
                     hover:bg-muted/30 hover:border-border/60
                     focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-1
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-background
                     shadow-sm hover:shadow"
        >
          <ChevronLeft className="w-4 h-4" strokeWidth={2} />
          <span>{t('COM_EASYFORMS_BACK', 'Back')}</span>
        </button>
      ) : (
        <div></div>
      )}

      {/* Next/Submit Button */}
      {navigation.isLastPage ? (
        <button
          onClick={submitForm}
          disabled={isSubmitting || hasErrors}
          className="inline-flex items-center justify-center gap-2 px-6 py-2.5 text-sm font-medium
                     !bg-primary !text-primary-foreground rounded-lg
                     transition-all duration-200
                     hover:bg-primary/90 hover:shadow-md
                     focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary disabled:hover:shadow-none
                     shadow-sm
                     ml-auto"
        >
          {isSubmitting ? (
            <>
              <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              <span>{t('COM_EASYFORMS_SUBMITTING', 'Submitting...')}</span>
            </>
          ) : (
            <>
              <span>
                {form.formType === 'quiz' ? t('COM_EASYFORMS_QUIZ_SUBMIT', 'Submit Quiz') : t('COM_EASYFORMS_FORM_SUBMIT', 'Submit')}
              </span>
              <Send className="w-4 h-4" strokeWidth={2} />
            </>
          )}
        </button>
      ) : (
        <button
          onClick={nextPage}
          disabled={isSubmitting || hasErrors || isDraftSaving}
          className="inline-flex items-center justify-center gap-2 px-6 py-2.5 text-sm font-medium
                     !bg-primary !text-primary-foreground rounded-lg
                     transition-all duration-200
                     hover:bg-primary/90 hover:shadow-md
                     focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary disabled:hover:shadow-none
                     shadow-sm
                     ml-auto"
        >
          <span>{t('COM_EASYFORMS_FORM_CONTINUE', 'Continue')}</span>
          <ChevronRight className="w-4 h-4" strokeWidth={2} />
        </button>
      )}
    </div>
  );
}
